<template>
  <span :class="`ui-spinner--${color}`" />
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
}
</script>

<style lang="scss">
.ui-spinner--white,
.ui-spinner--black {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.ui-spinner--white {
  border: 2px solid rgba(255,255,255,.3);
  border-top-color: #fff;
}

.ui-spinner--black {
  border: 2px solid rgba(49, 49, 49, 0.3);
  border-top-color: #313131;
}
</style>
